export const SLICE_NAMES = {
  ADMINISTRATION_SLICE: "administrationSlice",
  ARTICULATION_SLICE: "articulationSlice",
  CHAT_SLICE: "chatSlice",
  CONTENT_SLICE: "treatmentContentSlice",
  H5P_SLICE: "h5pGamesSlice",
  SPEECH_SLICE: "speechSlice",
  STUDENT_SIDE_SLICE: "treatmentStudentSideSlice",
  TECH_STATUS_SLICE: "techStatusSlice",
  TREATMENT_SERVER_DATA_SLICE: "treatmentServerDataSlice",
  STUDIO_SLICE: "studioSlice",
  VIDEO_SLICE: "videoSlice",
  WEBSOCKET_SLICE: "websocketSlice",
  YOUTUBE_SLICE: "youtubeSlice",
  ACTIVITY_LIBRARY: "activityLibrarySlice",
  CREATE_SESSION: "create-session",
};
